export default __webpack_public_path__ + "static/daughters-with-mother-22861f3911137c748a3d898a42304aa8.jpg";